import { Glue42 } from "../../glue";
import { ChannelsImpl } from "./channels";

let interop: Glue42.Interop.API;
let windowId: string;
const T42_ANNOUNCE_METHOD_NAME = "T42.Channels.Announce";

export interface WindowsWithChannels {
    windows: { windowId: string, channel: string, application: string }[];
}

export async function setupInterop(interopLib: Glue42.Interop.API, channels: ChannelsImpl) {
    interop = interopLib;

    if (typeof window !== "undefined") {
        if (window.glue42gd) {
            windowId = window.glue42gd.windowId;
        }
    }

    if (!windowId) {
        // not supported
        return;
    }

    await interop.register<{ command: string, channel: string }>("T42.Channels.Command", (args) => {
        const command = args.command;
        if (!command) {
            throw new Error("missing command argument");
        }
        if (command === "join") {
            const id = args.channel;
            if (!id) {
                throw new Error("missing argument id");
            }
            // this is coming from GD (which means from selector switch, join without triggering selection change again)
            channels.joinNoSelectorSwitch(id);
            return;
        }
        if (command === "leave") {
            channels.leaveNoSelectorSwitch();
            return;
        }
        if (command === "get") {
            const id = channels.current();
            return { id };
        }
        throw new Error(`unknown command ${command}`);
    });

    // agm interface is available for SW windows only
    await interop.invoke("T42.Channels.Announce", { swId: windowId, instance: interop.instance.instance });
}

export async function switchChannel(channel?: string, id?: string) {
    interop.invoke("T42.Channels.Announce", {
        swId: id ?? windowId,
        command: "switchChannel",
        data: { newChannel: channel }
    });
}

export async function getWindowsWithChannels(filter: Glue42.Channels.WindowWithChannelFilter): Promise<WindowsWithChannels> {
    const result = await interop.invoke<WindowsWithChannels>(T42_ANNOUNCE_METHOD_NAME, { command: "getChannelsInfo", data: { filter } });
    return result.returned;
}

export async function addOrRemoveChannel(command: "addChannel" | "removeChannel", id: string, color?: string) {
    await interop.invoke(T42_ANNOUNCE_METHOD_NAME, { command, data: { id, color } });
}
